import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { crmProspectDetails } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useSmsReply = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.patch(`${envVars.API_COMMERCE_HOSTNAME}crm/backoffice/reply-sms`, { message: attributes.message }, { ...params, params: { prospect_id: attributes.prospect_id } }),
        onSuccess: (_, attr) => {
            queryClient.invalidateQueries({ queryKey: [crmProspectDetails, attr.prospect_id] });
        }
    });
};
export default useSmsReply;
